import React from 'react';
import ImageUploader from '../../ImageUploader';

interface Props {
  file: File | null;
  imageUrl?: string;
  onUpload: (file: File) => void;
  onDelete: () => void;
}

const ProductImageUpload: React.FC<Props> = ({ file, imageUrl, onUpload, onDelete }) => {
  const currentImage = file
    ? URL.createObjectURL(file)
    : imageUrl || ''; 

  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-gray-800 text-lg font-semibold dark:text-white">
        Imagen del Producto
      </h3>
      <ImageUploader
        currentImage={currentImage}
        onUpload={onUpload}
        onDelete={onDelete}
      />
    </div>
  );
};

export default ProductImageUpload;
